import Query from '../utils/Query';

export default class SessionStatsService {

	static getAll(type, start_date, end_date) {
		const filter = {};
		type ? filter.type = type : null;
		start_date ? filter.start_date = start_date : null;
		end_date ? filter.end_date = end_date : null;
		return Query.get('/custom/session/stats', filter ? { filter } : undefined);
	}

	static getAllByHash(hash) {
		return Query.get('/custom/session/' + hash + '/stats');
	}

	static push(transactions = []) {
		return Query.post('/custom/transaction/run', transactions, undefined, false);
	}
}
